import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import {
  s, Trans,
} from '~/translations/Trans';

const hereLinkStyle = (theme: Theme) => css({
  background: 'none',
  border: 'none',
  color: theme.textColors.link,
  cursor: 'pointer',
  fontWeight: 'bold',
  padding: 0,
  textDecoration: 'underline',

  '&:hover': {
    color: theme.textColors.linkOnHover,
  },
});

export const DataTableEditCellExternalComponent = ({
  onClick,
}: Readonly<{
  onClick: () => void;
}>) => {

  return (
    <Trans i18nKey="salesforce.spreadsheetData.edit.inSalesforce.withLink">
      {s('prefix')}
      <button
        css={hereLinkStyle}
        onClick={onClick}
      />
      {s('suffix')}
    </Trans>
  );
};
